/** One place the app leaves React, so tests can watch it instead of fighting jsdom navigation. */
export function navigateTo(url: string): void {
  window.location.assign(url)
}
